import React from "react"
import { flexBox } from "style/style_snippets"
import { first } from "lodash"
import { GitForkIcon, EyeIcon, StarFillIcon } from "@primer/octicons-react"
import ScoreTag from "components/ProjectCard/components/ScoreTag"
import CardWrapper from "components/shared/CardWrapper"

const ProjectCard = props => {
  const {
    grid,
    description,
    forkCount,
    languages: { nodes },
    name,
    stargazerCount,
    url,
    watchers: { totalCount },
  } = props

  const projectCardStyle = {
    scoreContainer: {
      height: 35,
      ...flexBox.row,
      justifyContent: "flex-start",
      alignItems: "center",
    },
  }
  const openProject = () =>
    typeof window !== `undefined` ? window.open(url, "") : null

  return (
    <CardWrapper
      {...{
        tag: first(nodes) ? first(nodes).name : "foss",
        title: name,
        description,
        onClick: openProject,
        grid,
      }}
    >
      <div css={projectCardStyle.scoreContainer}>
        <ScoreTag {...{ icon: <StarFillIcon />, score: stargazerCount }} />
        <ScoreTag {...{ icon: <GitForkIcon />, score: forkCount }} />
        <ScoreTag {...{ icon: <EyeIcon />, score: totalCount }} />
      </div>
    </CardWrapper>
  )
}

export default ProjectCard
